import { DQActionType, EditorialFacebookPostNetwork } from './enums';

export const getNetworkLabel = (network: EditorialFacebookPostNetwork) => {
  switch (network) {
    case EditorialFacebookPostNetwork.FACEBOOK:
      return 'facebook';
    case EditorialFacebookPostNetwork.INSTAGRAM:
      return 'instagram';
    case EditorialFacebookPostNetwork.THREADS:
      return 'threads';
    case EditorialFacebookPostNetwork.PINTEREST:
      return 'pinterest';
    case EditorialFacebookPostNetwork.TWITTER:
      return 'twitter';
    case EditorialFacebookPostNetwork.REELS:
      return 'reels';
    case EditorialFacebookPostNetwork.TEXT_STATUS:
      return 'text status';
    case EditorialFacebookPostNetwork.WHATSAPP:
      return 'whatsapp';
    case EditorialFacebookPostNetwork.BLUESKY:
      return 'bluesky';
    case EditorialFacebookPostNetwork.YOUTUBE_SHORTS:
      return 'youtube-shorts';
    case EditorialFacebookPostNetwork.FACEBOOK_VIDEO:
      return 'facebook-video';
    case EditorialFacebookPostNetwork.LINKEDIN:
      return 'linkedin';
    case EditorialFacebookPostNetwork.TIKTOK:
      return 'tiktok';
    case EditorialFacebookPostNetwork.MSN:
      return 'msn';
    case EditorialFacebookPostNetwork.REDDIT:
      return 'reddit';
    default:
      return '-';
  }
};

export const getNetworkFromLabel = (networkLabel?: string) => {
  switch (networkLabel) {
    case 'facebook':
      return EditorialFacebookPostNetwork.FACEBOOK;
    case 'instagram':
      return EditorialFacebookPostNetwork.INSTAGRAM;
    case 'threads':
      return EditorialFacebookPostNetwork.THREADS;
    case 'pinterest':
      return EditorialFacebookPostNetwork.PINTEREST;
    case 'twitter':
      return EditorialFacebookPostNetwork.TWITTER;
    case 'reels':
      return EditorialFacebookPostNetwork.REELS;
    case 'text-status':
      return EditorialFacebookPostNetwork.TEXT_STATUS;
    case 'whatsapp':
      return EditorialFacebookPostNetwork.WHATSAPP;
    case 'bluesky':
      return EditorialFacebookPostNetwork.BLUESKY;
    case 'youtube-shorts':
      return EditorialFacebookPostNetwork.YOUTUBE_SHORTS;
    case 'facebook-video':
      return EditorialFacebookPostNetwork.FACEBOOK_VIDEO;
    case 'linkedin':
      return EditorialFacebookPostNetwork.LINKEDIN;
    case 'tiktok':
      return EditorialFacebookPostNetwork.TIKTOK;
    case 'msn':
      return EditorialFacebookPostNetwork.MSN;
    case 'reddit':
      return EditorialFacebookPostNetwork.REDDIT;
    default:
      return EditorialFacebookPostNetwork.FACEBOOK;
  }
};

export const getLastDistributedPostKey = (
  network: EditorialFacebookPostNetwork,
) => {
  const key = (() => {
    switch (network) {
      case EditorialFacebookPostNetwork.FACEBOOK:
        return 'lastDistributedFacebookPost';
      case EditorialFacebookPostNetwork.INSTAGRAM:
        return 'lastDistributedInstagramPost';
      case EditorialFacebookPostNetwork.THREADS:
        return 'lastDistributedThreadsPost';
      case EditorialFacebookPostNetwork.PINTEREST:
        return 'lastDistributedPinterestPost';
      case EditorialFacebookPostNetwork.TWITTER:
        return 'lastDistributedTwitterPost';
      case EditorialFacebookPostNetwork.REELS:
        return 'lastDistributedReelsPost';
      case EditorialFacebookPostNetwork.TEXT_STATUS:
        return 'lastDistributedTextStatusPost';
      case EditorialFacebookPostNetwork.WHATSAPP:
        return 'lastDistributedWhatsAppPost';
      case EditorialFacebookPostNetwork.BLUESKY:
        return 'lastDistributedBlueskyPost';
      case EditorialFacebookPostNetwork.YOUTUBE_SHORTS:
        return 'lastDistributedYtShortsPost';
      case EditorialFacebookPostNetwork.FACEBOOK_VIDEO:
        return 'lastDistributedFacebookVideoPost';
      case EditorialFacebookPostNetwork.LINKEDIN:
        return 'lastDistributedLinkedinPost';
      case EditorialFacebookPostNetwork.TIKTOK:
        return 'lastDistributedTiktokPost';
      case EditorialFacebookPostNetwork.MSN:
        return 'lastDistributedMsnPost';
      case EditorialFacebookPostNetwork.REDDIT:
        return 'lastDistributedRedditPost';
    }
  })();

  return key!;
};

export const getDQActionLabel = (type?: DQActionType) => {
  switch (type) {
    case DQActionType.CHANGE_FREQUENCY:
      return 'Change Frequency';
    case DQActionType.START_QUEUE:
      return 'Start Queue';
    case DQActionType.STOP_QUEUE:
      return 'Stop Queue';
    default:
      return '-';
  }
};
